//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import {detailData,saveData} from '@/api/flyback/flyback';
	import {getProjPersonPlanDataByConditon} from '@/api/pm/budget';
	import {guid,dateFormat} from '@/utils/common';
	import {getDicData,getPersonProjectData,getInnerUserData,getProvCityCascadeList} from '@/api/common/dic';
	import { Toast } from 'mint-ui';

	// 省份数据，暂时固定，不然第一次进来的时候不会有省份数据
	const provData = ["北京市", "天津市", "河北省", "山西省", "内蒙古自治区", "辽宁省", "吉林省", "黑龙江省", "上海市", "江苏省", "浙江省", "安徽省", "福建省", "江西省", "山东省", "河南省", "湖北省", "湖南省", "广东省", "广西壮族自治区", "海南省", "重庆市", "四川省", "贵州省", "云南省", "西藏自治区", "陕西省", "甘肃省", "青海省", "宁夏回族自治区", "新疆维吾尔自治区"];
	export default {
		name:'flybackApplyDetail',
		data(){
	      return {
	        mainId: this.$route.params.mainId,
	        // 类型：1:申请、2：折现
	        type:this.$route.params.type,
	        // 编辑标记：0:添加，1:编辑，2：查看
	        flag:this.$route.params.flag,
	        // 申请日期
	        applyDate:this.$route.params.applyDate,
	        // 是否显示审批及记录
	        showRecord:this.$route.params.showRecord,
	      	// 申请人员编号
	      	personCode:this.$route.params.personCode,
	        // 标题
	        title:'',
	      	// 主表数据，初始需要赋值的字段需要先初始化
	      	form:{
	      		id:'',
	      		projId:'',
	      		projCode:'',
	      		projName:'',
	      		applyDate:'',
	      		baseAddress:'',
	      		projAddress:'',
	      		transTypeCode:'',
	      		transTypeName:'',
	      		perCost:0,
	      		typeCode:'',
	      		typeName:'',
	      		fromAddressGo:'',
	      		toAddressGo:'',
	      		planToTime:null,
	      		fromAddressBack:'',
	      		toAddressBack:'',
	      		planBackTime:null,
	      		status:'待审批',
	      		discountAmt:null,
	      		remark:'',
	      		pmCode:'',
	      		pmName:'',
	      		pdCode:'',
	      		pdName:'',
	      		flybackType:'',
	      	},
	      	// 项目下拉数据
	      	projSelOptions:[],
	        // 行程定义
	        fbApplyTypeOptions:[],
	        // 行程类型
	        fbTravTypeOptions:[],
	      	// 交通类型
	      	trafficTypeOptions:[],
	      	// 预算中的人员信息
	      	projPersonInfo:{},
	      	// 省份城市数据
	      	cityData:{},
	      	openCitySelFlag:false,
	      	addressSlots: [
		        {
		          width: '100%',
		          textAlign: 'right',
		          values: provData
		        }, {
		          width: '100%',
		          textAlign: 'left',
		          values: ['北京市']
		        }
	       	],
	       	address:['北京市', '北京市'],
	      	addressProvince: '北京市',
	      	addressCity: '北京市',
	      	// 地址选择类型：1：出发地(往) 2：目的地(往) 3: 出发地(返) 4：目的地(返)
	      	addressSelType:'1',
	      }
		},
		created(){
			// 字典表等数据
			this.dicFn();
			if(this.type === '1'){
				this.title = "差旅申请";
			}else if(this.type === '2'){
				this.title = "flyback折现";
			}
			if(this.flag === '0'){
				this.form.id = guid();
				this.mainId = this.form.id;
				this.form.flybackType = (this.type === '1'?'申请':'折现');
				this.form.applyDate = this.applyDate;
			}else{
				// 加载数据
				this.loadData();

				if(this.flag === '2'){
					// 查看的情况下
					
				}
			}
		},
		computed:{

		},
		mounted: function(){
		},
		methods:{
			//时间格式化
			dateFormatter(date) {
				return dateFormat(date);
			},
			// 返回
			goback(){
        		this.$router.go(-1);
			},
			// 项目选择改变事件
			projSelChange(value){
		      var self = this;
		      let obj = {};
		      obj = self.projSelOptions.find((item)=>{
		        return item.projCode === value;
		      });
		      self.form.projName = (obj===undefined?'':obj.projName);
		      self.form.projId = (obj===undefined?'':obj.id);
		      self.form.pmCode = (obj===undefined?'':obj.pmCode);
		      self.form.pmName = (obj===undefined?'':obj.pmName);
		      self.form.pdCode = (obj===undefined?'':obj.pdCode);
		      self.form.pdName = (obj===undefined?'':obj.pdName);

		      // 不是查看情况下 需要重新获取预算数据
		      if(this.flag !== '2'){
			      // 获取登陆人员预算人员计划数据
				  self.getProjPersonPlanDataByConditon(obj.city);
		      }
			},
			// 获取登陆人员预算人员计划数据
			getProjPersonPlanDataByConditon(projAddress){
				// 获取登陆人员预算人员计划数据  personCode='' ， 当前登录人员
			    var condition = {projId:this.form.projId,personCode:this.personCode,personType:'1'};
			    getProjPersonPlanDataByConditon(condition).then(response => {
			        if(response != null && response.length>0){
			          	this.projPersonInfo = response[0];
					    if(this.projPersonInfo != null && this.projPersonInfo != undefined){
			          	  this.form.baseAddress = this.projPersonInfo.city;
			          	  this.form.projAddress = projAddress;
			          	  this.form.transTypeCode = this.projPersonInfo.trafficTypeCode;
			          	  this.form.transTypeName = this.projPersonInfo.trafficTypeName;
			         	  this.form.perCost = this.projPersonInfo.perCost;
					    }
			        }
			    });
			},
			// 类型选择改变事件
			typeSelChange(value){
		      let obj = {};
		      obj = this.fbApplyTypeOptions.find((item)=>{
		        return item.dicCode === value;
		      });
		      this.form.typeName = (obj===undefined?'':obj.dicName);
		      if(value === '001'){
		      	// 到达目的地
		      	this.form.fromAddressBack = '';
		      	this.form.toAddressBack = '';
		      	this.form.planBackTime = null;
		      }else if(value === '002'){
		      	// 返回base地
		      	this.form.fromAddressGo = '';
		      	this.form.toAddressGo = '';
		      	this.form.planToTime = null;
		      }
			},
			// flyback提交
			submitClick(){
				// 判断必填字段是否填写
				var checkFlag = this.check();
				if(checkFlag){
					var flybackApplyData = JSON.stringify(this.form);
					var condition = {flybackApplyData:flybackApplyData,flag:this.flag,isSubmit:1};
					saveData(condition).then(response => {
				        if(response.flag === 'S'){
		    				// 提交情况下
		    				Toast({
							  message: '提交成功！',
							  position: 'middle',
							  duration: 1500,
							  className:'success'
							});
		    				// 返回列表界面
		    				this.goback();
				        }else{

		    				Toast({
							  message: '提交失败：'+response.msg,
							  position: 'middle',
							  duration: 1500,
							  className:'warning'
							});
				        }
				    });
				}
			},
			// 检查必填项
			check(){
				// 项目
				if(this.form.projId === null || this.form.projId === undefined || this.form.projId === ''){
					Toast({
					  message: '请选择项目！',
					  position: 'middle',
					  duration: 1500,
					  className:'info'
					});
		    		return false;
				}

		        // 单边费用
		        if(this.form.perCost === null || this.form.perCost === undefined || this.form.perCost.toString().trim() === '' 
		          || isNaN(this.form.perCost) || this.form.perCost.toString().indexOf(" ")>-1){
			        Toast({
					  message: '请填写单边费用！',
					  position: 'middle',
					  duration: 1500,
					  className:'info'
					});
		            return false;
		        }
				// 申请
				if(this.type === '1'){

					if(this.form.typeCode === null || this.form.typeCode === undefined || this.form.typeCode === ''){
						Toast({
						  message: '请选择行程定义！',
						  position: 'middle',
						  duration: 1500,
						  className:'info'
						});
			    		return false;
					}
		            if(this.form.travType === null || this.form.travType === undefined || this.form.travType === ''){
		                Toast({
						  message: '请选择行程类型！',
						  position: 'middle',
						  duration: 1500,
						  className:'info'
						});
		                return false;
		            }

					if(this.form.typeCode === '001' || this.form.typeCode === '003'){
						if(this.form.fromAddressGo===null || this.form.fromAddressGo===undefined || this.form.fromAddressGo===''
							|| this.form.toAddressGo===null || this.form.toAddressGo===undefined || this.form.toAddressGo===''){
							Toast({
							  message: '请选择出发地(到达)或目的地(到达)！',
							  position: 'middle',
							  duration: 1500,
							  className:'info'
							});
				    		return false;
						}
						if(this.form.planToTime===null || this.form.planToTime===undefined || this.form.planToTime===''){
				    		Toast({
							  message: '请选择出发时间！',
							  position: 'middle',
							  duration: 1500,
							  className:'info'
							});
				    		return false;
				    	}
					}

					if(this.form.typeCode === '002' || this.form.typeCode === '003'){
						if(this.form.fromAddressBack===null || this.form.fromAddressBack===undefined || this.form.fromAddressBack===''
							|| this.form.toAddressBack===null || this.form.toAddressBack===undefined || this.form.toAddressBack===''){
							Toast({
							  message: '请选择出发地(返回)或目的地(返回)！',
							  position: 'middle',
							  duration: 1500,
							  className:'info'
							});
				    		return false;
						}
						if(this.form.planBackTime===null || this.form.planBackTime===undefined || this.form.planBackTime===''){
				    		Toast({
							  message: '请选择返回时间！',
							  position: 'middle',
							  duration: 1500,
							  className:'info'
							});
				    		return false;
				    	}
				    }
				}
				
				// 折现
				if(this.type === '2'){
					if(this.form.planToTime===null || this.form.planToTime===undefined || this.form.planToTime===''
						|| this.form.planBackTime===null || this.form.planBackTime===undefined || this.form.planBackTime===''){
			    		Toast({
						  message: '请选择往返回时间！',
						  position: 'middle',
						  duration: 1500,
						  className:'info'
						});
			    		return false;
			    	}
			    	if(this.form.discountAmt === null || isNaN(this.form.discountAmt) || this.form.discountAmt.toString().trim() === '' 
			    		|| this.form.discountAmt === undefined || this.form.discountAmt.toString().indexOf(" ")>-1){
			    		Toast({
						  message: '请填写折现金额！',
						  position: 'middle',
						  duration: 1500,
						  className:'info'
						});
			    		return false;
			    	}
				}

				return true;
			},
		    // 加载数据
		    loadData(){
		        var condition = {'applyId':this.mainId};
		        detailData(condition).then(response => {
		        	// 数据赋值
	          		this.form = response.flybackApply;
		        });
		    },
		    addressChange(value, index) {
		      switch (index) {
		        case 0:
		          this.addressProvince = value;
		          const arr = this.cityData[value];
		          this.addressSlots[1].values = arr;
		          this.addressCity = arr[0];
		          break;
		        case 1:
		          this.addressCity = value;
		          break;
		      }
		      this.address = [this.addressProvince, this.addressCity]
		    },
		    // 交通类型改变事件
		    changeTrafficTypeEvent(value){
		      let obj = {};
		      obj = this.trafficTypeOptions.find((item)=>{
		        return item.dicCode === value;
		      });
		      this.form.transTypeName = (obj===undefined?'':obj.dicName);
		    },
		    cityClick(type){
		    	this.openCitySelFlag = true;
		    	this.addressSelType = type;
		    },
		    // 城市确认事件
		    cityConfirmClick(){
		    	this.openCitySelFlag = false;

		    	if(this.addressSelType === '1'){
		    		// 出发地 往
		    		this.form.fromAddressGo = this.addressCity;
		    	}else if(this.addressSelType === '2'){
		    		// 目的地 往
		    		this.form.toAddressGo = this.addressCity;
		    	}else if(this.addressSelType === '3'){
		    		// 出发地 返
		    		this.form.fromAddressBack = this.addressCity;
		    	}else if(this.addressSelType === '4'){
		    		// 目的地 返
		    		this.form.toAddressBack = this.addressCity;
		    	}
		    },
		    // 字典表等数据
		    dicFn(){
		        // flyback行程定义
		        var condition = {'cateCode':'flybackApplyType'};
		        getDicData(condition).then(response => {
		          this.fbApplyTypeOptions = response;
		        });
		        // flyback行程类型
		        var condition = {'cateCode':'travType'};
		        getDicData(condition).then(response => {
		          this.fbTravTypeOptions = response;
		        });

		        // 获取登录人员的项目信息，personCode='' 取登录人员项目
		        condition = {personCode:this.personCode};
		        getPersonProjectData(condition).then(response => {
		          this.projSelOptions = response.list;
		        });

		        // 交通类型
		        condition = {'cateCode':'trafficType'};
		        getDicData(condition).then(response => {
		          this.trafficTypeOptions = response;
		        });

		        // 获取省份城市级联数据
		        condition = {type:'prov'};
		        getProvCityCascadeList(condition).then(response => {
		        	this.provCityDeal(response);
		        });
		    },
		    // 省份、城市处理
		    provCityDeal(data){
		        this.cityData = [];
		        //provData = [];
		        for(var i=0;i<data.length;i++){
		        	var item = data[i];
		        	// 省份数据
		        	//provData.push(item.name);
		        	// 城市
		        	var cities = item.cities;
		        	var cityArr = new Array();
		        	for(var j=0;j<cities.length;j++){
		        		cityArr.push(cities[j].name);
		        	}
		        	this.cityData[item.name] = cityArr;
		        }
		    }
    	}
	}



// WEBPACK FOOTER //
// ./src/view/flyback/flybackApplyDetail.vue